<template>
  <svg
    width="164"
    height="222"
    viewBox="0 0 164 222"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer_1" clip-path="url(#clip0_2751_1593)">
      <g id="Group">
        <path
          id="Vector"
          d="M0 94.5234L59.9409 143.602L106.215 192.701C87.7559 189.862 47.3186 161.112 31.0303 146.058C14.7449 131.001 4.20046 112.624 0 94.5234Z"
          fill="#CBEFE1"
        />
        <path
          id="Vector_2"
          d="M0 94.5234L106.215 192.701C102.014 174.598 70.2286 136.584 53.9402 121.531C37.6549 106.477 18.4557 97.3625 0 94.5234Z"
          fill="#CBEFE1"
        />
        <path
          id="Vector_3"
          d="M4.35547 98.5498L61.1855 146.316L106.214 192.701C89.9827 188.406 52.092 159.882 36.4724 145.443C20.8528 131.007 9.85159 114.334 4.35547 98.5469V98.5498Z"
          fill="#CBEFE1"
        />
        <path
          id="Vector_4"
          d="M4.35547 98.5508L106.214 192.702C100.718 176.914 69.3446 141.414 53.725 126.978C38.1054 112.541 20.5871 102.848 4.35547 98.5508Z"
          fill="#49E2A7"
        />
      </g>
      <g id="Group_2">
        <path
          id="Vector_5"
          d="M35.1775 18.417L62.1356 105.559L75.6177 183.878C59.2905 169.136 38.2494 114.644 32.0488 89.2701C25.8481 63.8962 27.4751 38.9679 35.1775 18.4141V18.417Z"
          fill="#CBEFE1"
        />
        <path
          id="Vector_6"
          d="M35.1777 18.418L75.621 183.879C83.3203 163.325 76.8629 105.305 70.6592 79.934C64.4585 54.5602 51.5049 33.16 35.1777 18.418Z"
          fill="#CBEFE1"
        />
        <path
          id="Vector_7"
          d="M36.8369 25.2051L61.5918 109.039L75.6232 183.88C62.4397 169.144 43.763 116.523 37.8161 92.1914C31.8692 67.86 31.9289 44.3156 36.8399 25.2051H36.8369Z"
          fill="#CBEFE1"
        />
        <path
          id="Vector_8"
          d="M36.8369 25.2051L75.6203 183.88C80.5312 164.77 72.8349 109.49 66.888 85.159C60.941 60.8276 50.0204 39.9411 36.8369 25.2051Z"
          fill="#49E2A7"
        />
      </g>
      <g id="Group_3">
        <path
          id="Vector_9"
          d="M99.3891 -1.41032L82.4792 88.1968L77.9529 167.532C92.4916 151.061 107.217 94.5597 110.505 68.6534C113.793 42.7471 109.356 18.1539 99.3888 -1.41328L99.3891 -1.41032Z"
          fill="#CBEFE1"
        />
        <path
          id="Vector_10"
          d="M99.3801 -1.41082L77.1699 173.525C67.2055 153.959 67.8199 89.5876 71.1098 63.6838C74.3994 37.777 84.8383 15.0617 99.3801 -1.41082Z"
          fill="#CBEFE1"
        />
        <path
          id="Vector_11"
          d="M98.5048 5.52291L83.4135 91.5954L77.9496 167.536C89.3677 151.422 101.957 97.0448 105.109 72.2036C108.262 47.3595 105.54 23.9728 98.5051 5.52587L98.5048 5.52291Z"
          fill="#49E2A7"
        />
        <path
          id="Vector_12"
          d="M98.5014 5.52328L77.9468 167.533C70.9125 149.086 72.3036 93.2948 75.4561 68.4537C78.6083 43.6097 87.0839 21.6377 98.5044 5.52297L98.5014 5.52328Z"
          fill="#CBEFE1"
        />
      </g>
      <g id="Group_4">
        <path
          id="Vector_13"
          d="M163.999 48.1484L106.766 119.364L65.3252 187.295C85.9513 179.543 125.633 136.535 140.763 115.2C155.893 93.8623 163.578 70.0803 163.999 48.1484Z"
          fill="#CBEFE1"
        />
        <path
          id="Vector_14"
          d="M164 48.1484L65.3232 187.295C65.7442 165.363 93.1621 113.751 108.295 92.416C123.425 71.0781 143.374 55.9025 164 48.1484Z"
          fill="#CBEFE1"
        />
        <path
          id="Vector_15"
          d="M159.951 53.8594L105.99 122.803L65.3232 187.298C83.0237 178.403 119.816 136.274 134.325 115.815C148.837 95.3531 157.465 73.4332 159.951 53.8623V53.8594Z"
          fill="#49E2A7"
        />
        <path
          id="Vector_16"
          d="M159.951 53.8594L65.3232 187.298C67.8101 167.727 95.3653 119.117 109.874 98.6555C124.386 78.1938 142.251 62.7539 159.949 53.8594H159.951Z"
          fill="#CBEFE1"
        />
      </g>
      <path
        id="Vector_17"
        d="M89.8214 222.001H67.41L53.3428 196.244L70.1804 160.021H102.503C107.537 168.298 110.516 177.941 110.516 186.946C110.516 202.014 102.166 215.141 89.8184 222.001H89.8214Z"
        fill="#1B3352"
      />
      <path
        id="Vector_18"
        d="M50.5396 222.001C38.192 215.141 29.8418 202.014 29.8418 186.946C29.8418 177.941 32.8212 168.298 37.8546 160.021H70.1805V222.001H50.5396Z"
        fill="#A6A5A5"
      />
      <path
        id="Vector_19"
        d="M109.914 179.757H70.1811L61.6279 174.768L70.1811 167.207H106.206C107.961 171.285 109.227 175.531 109.917 179.757H109.914Z"
        fill="#A6A5A5"
      />
      <path
        id="Vector_20"
        d="M30.4453 179.757H70.181V167.207H34.1562C32.4037 171.285 31.1349 175.531 30.4453 179.757Z"
        fill="#1B3352"
      />
    </g>
    <defs>
      <clipPath id="clip0_2751_1593">
        <rect width="164" height="222" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
